import React from "react";

const Checkbox = ({ disabled, checked, onChange, ariaLabel }) => {
   return (
      <label style={{ display: "flex", alignItems: "center", cursor: disabled ? "not-allowed" : "pointer", opacity: disabled ? 0.5 : 1 }}>
         <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke={disabled ? "text-dark-50" : "currentColor"}
            strokeWidth="1"
            strokeLinecap="round"
            strokeLinejoin="round"
            style={{ marginRight: "8px" }}>
            <rect
               x="3"
               y="3"
               width="18"
               height="18"
               rx="2"
               ry="2"
               style={{ fill: checked ? "#007bff" : "none", stroke: checked ? "#007bff" : "#16191f" }}
            />
            {checked && (
               <path
                  d="M7 12l5 5L17 8"
                  style={{ fill: "none", stroke: "#fff", strokeWidth: "2" }}
               />
            )}
         </svg>
         <input
            type="checkbox"
            disabled={disabled}
            checked={checked}
            onChange={onChange}
            style={{ display: "none" }}
            aria-label={ariaLabel}
         />
         {ariaLabel && <span style={{ marginLeft: "8px" }}>{ariaLabel}</span>}
      </label>
   );
};

export default Checkbox;
